import khaukaniImg from '../assets/blog/cards/khaukani.jpg';
import responseImg from '../assets/blog/cards/response.jpg';

import type { Product } from './types/product';

export const products: Product[] = [
  {
    id: 'qcare',
    slug: 'qcare',
    title: 'qCare; Response App',
    tags: ['Apps', 'Emergency', 'AI', 'Medical'],
    description:
      'A mobile and backend system connecting emergency response workflows with real-time data and coordination.',
    longDescription:
      "qCare is an on-demand emergency response app that connects users to the nearest available ambulances, doctors, and paramedics—much like Uber, but for critical medical help. Designed for speed and reliability, qCare enables users to request urgent care services in real time, track responders en route, and receive timely assistance when every second counts. Whether it's a medical emergency at home, on the road, or in public, qCare ensures professional help is just a tap away.",
    image: responseImg,
    authorId: 'tonny-shimanyi',
    date: '2025-02-20',
    caseStudy: {
      about:
        "qCare is an on-demand emergency response app that connects users to the nearest available ambulances, doctors, and paramedics—much like Uber, but for critical medical help. Designed for speed and reliability, qCare enables users to request urgent care services in real time, track responders en route, and receive timely assistance when every second counts.",
      challenge:
        'Emergency medical response in many regions lacks real-time coordination between patients, dispatchers, and responders — leading to delayed arrivals and fragmented communication during critical moments.',
      solution:
        'We built a mobile app and backend system that matches users with the nearest available responders, provides live tracking, and coordinates dispatch workflows with real-time data across the emergency response chain.',
      results:
        'qCare reduced response coordination time and gave users visibility into responder location and ETA, improving trust and speed during medical emergencies.',
      stats: [
        { value: '<2min', label: 'Average Dispatch', context: 'Time' },
        { value: '24/7', label: 'Availability', context: 'Coverage' },
        { value: 'Live', label: 'Responder Tracking', context: 'Real-time' },
      ],
    },
  },
  {
    id: 'khaukani',
    slug: 'khaukani',
    title: 'Khaukani; Giveback for Education',
    tags: ['Education', 'Giveback'],
    description:
      'Khaukani, developed by the Khaukani Foundation, is a platform designed to enhance the process of giving back—specifically for schools in Kenya.',
    longDescription:
      'Khaukani, developed by the Khaukani Foundation, is a platform designed to enhance the process of giving back—specifically for schools in Kenya. It offers a portal where alumni and other well-wishers can organize and contribute funds toward school-related causes. The platform also ensures transparency by tracking how the funds are spent on the designated initiatives.',
    image: khaukaniImg,
    authorId: 'tonny-shimanyi',
    date: '2025-01-21',
    caseStudy: {
      about:
        'Khaukani, developed by the Khaukani Foundation, is a platform designed to enhance the process of giving back—specifically for schools in Kenya. It offers a portal where alumni and other well-wishers can organize and contribute funds toward school-related causes.',
      challenge:
        'Schools in Kenya struggled to organize alumni giving campaigns and lacked transparent ways to show donors how contributions were being used on specific initiatives.',
      solution:
        'We created a giving portal where alumni and well-wishers can contribute to school causes, with full fund tracking and transparency reporting on how donations are spent.',
      results:
        'Khaukani increased alumni engagement and gave schools a trusted platform to run fundraising campaigns with visible impact reporting for every contribution.',
      stats: [
        { value: '100%', label: 'Fund Transparency', context: 'Tracked' },
        { value: '50+', label: 'Schools', context: 'Supported' },
        { value: '2x', label: 'Donor Engagement', context: 'Increase' },
      ],
    },
  },
];

export const productsById = Object.fromEntries(products.map((product) => [product.id, product])) as Record<
  string,
  Product
>;
export const productsBySlug = Object.fromEntries(products.map((product) => [product.slug, product])) as Record<
  string,
  Product
>;
